import { Inject, Pipe, PipeTransform } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { capitalize } from 'lodash';

@Pipe({
  name: 'selected'
})
export class SelectedPipe implements PipeTransform {

  constructor(
    @Inject(MAT_DIALOG_DATA) public form: FormGroup,
  ) { }

  transform(label: string): boolean {
    const amenities = this.form.get('gygTour')?.get('amenities')! as FormArray;
    const data = (amenities.value as string[]).map(value => {
      return value
        ?.toLowerCase()
        ?.replace(/\b\w+/g, (word) => capitalize(word));
    });
    
    return data.includes(label);
  }

}
